import { Text } from "../../../../components/common/typography";

export function ProductRow({
  image,
  name,
  sub,
  right,
  onClick,
}: {
  image: string;
  name: string;
  sub: string;
  right: React.ReactNode;
  onClick?: () => void;
}) {
  const interactive = Boolean(onClick);
  return (
    <div
      role={interactive ? "button" : undefined}
      tabIndex={interactive ? 0 : undefined}
      onClick={onClick}
      onKeyDown={interactive ? (e) => { if (e.key === "Enter" || e.key === " ") { e.preventDefault(); onClick?.(); } } : undefined}
      className={`flex items-center gap-4 rounded-2xl border border-borderDefault px-4 py-3 max-md:gap-3 max-md:px-3 ${interactive ? "cursor-pointer transition-colors hover:bg-bgLight focus:outline-none focus-visible:ring-2 focus-visible:ring-brandPrimary" : ""}`}
    >
      <div className="size-12 shrink-0 overflow-hidden rounded-xl bg-bgLight">
        <img src={image} alt="" className="size-full object-cover" />
      </div>
      {/* Phones: the right-hand chip drops under the name so it keeps its width. */}
      <div className="flex min-w-0 flex-1 items-center gap-4 max-md:flex-col max-md:items-start max-md:gap-1.5">
        <div className="flex min-w-0 flex-1 flex-col gap-0.5 max-md:w-full">
          <Text variant="bodyBold" tone="dark" className="truncate">
            {name}
          </Text>
          <Text variant="bodySm" tone="muted">
            {sub}
          </Text>
        </div>
        {right}
      </div>
    </div>
  );
}
